import { Button, Flex, Text, useDisclosure } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { CardItem } from './CardItem'

import { baseURL } from '../../../services/api'

export function UploadLayout({ item, onClose }) {
  const [itens, setItens] = useState([])

  console.log('item', item)

  async function onSubmit(data) {
    const params = {
      numero_nota: item.numero_nota,
      codigo_produto: item.codigo_produto,
      sequencia: item.sequencia,
      identificador: item.id,
    }

    const response = await baseURL.post('/fluxo-layout/listar-layouts-pendentes', params)

    console.log('params', params)

    setItens(response.data)
  }

  useEffect(() => {
    onSubmit()
  }, [item.numero_nota])

  const isIlustracao = item?.ilustracao

  return (
    <>
      <Flex maxW={'800px'} w={'100%'} mx={'auto'} flexDir={'column'} gap={2} mt={'1rem'}>
        {itens[0]?.liberacao_layout === 'S' ? (
          <>
            <Text
              as={'h1'}
              fontSize={'1.5rem'}
              fontWeight={'bold'}
              color={'gray.500'}
              opacity={itens.length > 0 ? 1 : 0}
              transition={'all 0.3s ease-in-out'}
            >
              Layouts
            </Text>
            {itens.map((i, index) => (
              <CardItem
                key={i.sequencia}
                baseLayout={item.base_ilustracoes}
                item={i}
                index={index}
                onSubmit={onSubmit}
                onClose={onClose}
                isIlustracao={isIlustracao}
              />
            ))}

            {/*<Button onClick={liberacaoLayout} isDisabled={buttonDisable}>*/}
            {/*  <>*/}
            {/*    <FiUpload size={20} />*/}
            {/*    <Text ml={2}>Enviar Layout</Text>*/}
            {/*  </>*/}
            {/*</Button>*/}
          </>
        ) : (
          <Text as={'h1'} fontSize={'1.5rem'} fontWeight={'bold'} color={'gray.500'} opacity={itens.length > 0 ? 1 : 0} textAlign={'center'}>
            É necessário abrir a logo antes de iniciar o layout
          </Text>
        )}
      </Flex>
    </>
  )
}
